// src/pages/IndirectIncomeBalanceLedger/components/IndirectIncomeBalanceLedgerFilters.js
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../IndirectIncomeBalanceLedgerSlice";
import {
  fetchIndirectIncomeBalanceLedger,
  fetchIndirectIncomeAccountsBySearch,
} from "../IndirectIncomeBalanceLedgerThunk";
import { fetchCustomersBySearch } from "../../../../store/commonThunks/lookups";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const IndirectIncomeBalanceLedgerFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.indirectIncomeBalanceLedger);

  useDefaultDateRange(setFilters, filters, "today");

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };
  const searchAccount = useCallback(
    (text) => dispatch(fetchIndirectIncomeAccountsBySearch(text)),
    [dispatch]
  );

  const handleReport = () => {
    if (!filters.accId) {
      messageApi.warning("Select Account");
      return;
    }

    dispatch(fetchIndirectIncomeBalanceLedger({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row
        gutter={[16, 16]}
        align="middle"
        wrap
        style={{ alignItems: "center" }}
      >
        <Col xs={24} sm={12} md={4} lg={6}>
          <label>Search Account</label>
          <SearchListAutoComplete
            entityType="indirect_account"
            searchThunk={searchAccount}
            resultSelector={(state) =>
              state.indirectIncomeBalanceLedger.indirectAccounts
            } // 🔑 redux results
            onSelect={(obj) => {
              if(!obj) {
                handleFilterChange("accId", null);
                return;
              } 
              handleFilterChange("accId", obj?.sale_id);
            }}
            placeholder="Search Account"
            showAddNew={false}
          />
        </Col>

        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
          handleFilterChange("fromDate", fromDate);
          handleFilterChange("toDate", toDate);
          }}
        />

        <Col
          xs={24}
          sm={12}
          md={12}
          lg={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{height: 35.19}}
            data-testid="report-btn"
          >
            Report
          </Button>
        </Col>
      </Row>
      <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
      @media (min-width: 768px) {
  :where(.css-dev-only-do-not-override-1j5i8gz).ant-col-md-4 {
    max-width: none !important;
    flex: none !important;
  }
}
  `}</style>
    </Card>
  );
};

export default IndirectIncomeBalanceLedgerFilters;
